/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Flow_Engine_BodyInputs */

const en_services_flow_engine_body = /** @type {(inputs: Services_Flow_Engine_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Context, business rules and approvals`)
};

const lv_services_flow_engine_body = /** @type {(inputs: Services_Flow_Engine_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konteksts, biznesa noteikumi un apstiprinājumi`)
};

/**
* | output |
* | --- |
* | "Context, business rules and approvals" |
*
* @param {Services_Flow_Engine_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_flow_engine_body = /** @type {((inputs?: Services_Flow_Engine_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Flow_Engine_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_flow_engine_body(inputs)
	return en_services_flow_engine_body(inputs)
});